import { useTranslation } from 'react-i18next'
import Spinner from '~/components/Spinner'
import { Button } from '~/components/ui/button'
import { Card, CardContent } from '~/components/ui/card'

type IProps = {
  failed: boolean
  onRetry: () => void
}

/**
 * Ce qui tient la place des résultats tant qu'ils ne sont pas là (#243) : un
 * chargement, ou un échec dit comme tel — sans quoi une erreur se lirait comme
 * l'absence du droit de voir les statistiques.
 */
function SessionResultsPlaceholder({ failed, onRetry }: IProps) {
  const { t } = useTranslation()

  return (
    <Card>
      <CardContent className="flex flex-col items-center gap-3 p-8 text-center">
        {failed
          ? (
              <>
                <p role="alert" className="text-sm">{t('sessionDetail.results.failed')}</p>
                <Button variant="outline" onClick={onRetry}>{t('sessionDetail.results.retry')}</Button>
              </>
            )
          : (
              <p role="status" className="flex items-center gap-2 text-sm text-muted-foreground">
                <Spinner className="size-4" />
                {t('sessionDetail.results.loading')}
              </p>
            )}
      </CardContent>
    </Card>
  )
}

export default SessionResultsPlaceholder
